/**
 * Floating bottom action bar shown when one or more rows are selected.
 * Used by Companies + Inventory bulk-edit flows.
 */
import { X, Pencil } from "lucide-react";

export default function BulkActionBar({ count, onEdit, onClear, label = "selected", testid = "bulk-action-bar" }) {
  if (count === 0) return null;
  return (
    <div
      data-testid={testid}
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-30 bg-zinc-900 text-white shadow-xl rounded-sm border border-zinc-700 flex items-center gap-4 px-4 py-2.5 animate-fade-in"
    >
      <button onClick={onClear} className="text-zinc-300 hover:text-white" data-testid="bulk-clear" title="Clear selection">
        <X className="w-4 h-4" />
      </button>
      <div className="text-sm font-mono">
        <span className="font-bold text-brand-400" data-testid="bulk-count">{count}</span> {label}
      </div>
      <div className="w-px h-6 bg-zinc-700" />
      <button
        onClick={onEdit}
        data-testid="bulk-edit-button"
        className="inline-flex items-center gap-2 h-8 px-3 bg-brand-600 hover:bg-brand-700 text-white text-sm font-semibold rounded-sm transition-colors"
      >
        <Pencil className="w-3.5 h-3.5" /> Bulk edit
      </button>
    </div>
  );
}
